module.exports = __webpack_public_path__ + "static/media/pen-fancy.d7573ccb.svg";